import { Box } from '@mui/material'
import { ProgressLoaders, SvgImage } from 'components/ui'
import { MESSAGES } from 'config'
import { useAuth } from 'context'
import { useSnackbar } from 'notistack'
import { useMemo, useState } from 'react'
import { screenType, useWindowSize } from 'utils'
import { CloseButton, ICModal, ICModalContent } from './CloudPay'

interface IInvoiceCloudFrame {
  page?: number
  children: React.ReactNode
}

export const InvoiceCloudFrame = ({ page, children }: IInvoiceCloudFrame): JSX.Element => {
  const { width } = useWindowSize()
  const { enqueueSnackbar } = useSnackbar()
  const [visible, setVisible] = useState<boolean>(false)
  const [refresher, setRefresher] = useState<number>(1)
  const { icAuth } = useAuth()
  const [isIframeLoaded, setIsIframeLoaded] = useState<boolean>(false)

  const handleShow = (): void => {
    if ((icAuth == null) && page !== 0) {
      enqueueSnackbar(MESSAGES.IC_RETRIEVE_ERROR, { variant: 'error' })
    } else if (icAuth != null) {
      setVisible(true)
    }

    if (page == null) {
      setVisible(false)
    }
  }


  const handleHide = (): void => {
    setVisible(false)
    setRefresher(refresher + 1)
  }

  const iframeUrl = useMemo(() => {
    if (!visible || !icAuth) return ''
    return `https://www.invoicecloud.com/portal/remoteauth/customerportalredirect.aspx?RemoteAuthenticationToken=${icAuth}&ViewMode=1&RedirectID=${page}&CSSUrl=${process.env.REACT_APP_IC_STYLESHEET_URL}`
  }, [visible, icAuth, page])

  return (
    <>
      <Box
        sx={{
          // width: '100%',
          // height: '100%',
          padding: 0,
          margin: 0,
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          textTransform: 'none',
          fontFamily: 'var(--bs-body-font-family)',
          fontSize: 'var(--bs-font-size-m)'
        }}
        onClick={handleShow}
        component="div"
      >
        {children}
      </Box>

      <ICModal visible={visible ? 'true' : 'false'} onClick={handleHide}>
        <ICModalContent
          ismobile={screenType(width, 'sm') ? 'true' : 'false'}
          onClick={(e) => { e.stopPropagation() }}
        >
          <CloseButton
            sx={{ margin: screenType(width, 'sm') ? '5px' : '0' }}
            onClick={handleHide}
          >
            <SvgImage name="CloseIcon" width={24} height={24} />
          </CloseButton>

          {(icAuth != null) && visible && (iframeUrl.length > 0) && (
            <>
              {!isIframeLoaded && <ProgressLoaders height={screenType(width, 'sm') ? '90%' : '550px'} />}
              <iframe
                key={refresher}
                allow="payment"
                src={iframeUrl}
                width="100%"
                height={screenType(width, 'sm') ? '90%' : '550px'}
                title="InvoiceCloud frame"
                onLoad={() => { setIsIframeLoaded(true) }}
                style={{ display: isIframeLoaded ? 'block' : 'none' }}
              />
            </>
          )}
        </ICModalContent>
      </ICModal>


    </>
  )
}
